<template>
  <div class="t100-container">
    <companyHead :detail="companyData"></companyHead>
    <companyWorks
      :list="companyData.works"
      v-show="companyData.works.length"
    ></companyWorks>
    <companyArticle
      :list="companyData.articles"
      v-show="companyData.articles.length"
    ></companyArticle>
  </div>
</template>
<script>
import companyHead from "./components/company-head";
import companyWorks from "./components/company-works";
import companyArticle from "./components/company-article";
import * as API from "@/api";
export default {
  components: { companyHead, companyWorks, companyArticle },
  data() {
    return {
      loading: false,
      companyData: {
        works: [],
        articles: [],
      },
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    const { toWork } = this.$route.query;
  },
  methods: {
    async getData() {
      this.loading = true;
      const res = await API.getCompanyDetail(this.$route.params.id);
      this.companyData = res;
      this.loading = false;
      document.title = res.service_name + " - " + "投票頁" || "投票頁";
      if (this.$route.query.toWork) {
        this.scrollToWorks();
      } else {
        this.scrollTohead();
      }
    },
    scrollToWorks() {
      this.$nextTick(() =>
        document.querySelector(".company-detail-work").scrollIntoView({
          block: "start",
        })
      );
    },
    scrollTohead() {
      this.$nextTick(() =>
        document.querySelector(".company-container-wrapper").scrollIntoView({
          block: "start",
        })
      );
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/styles/var.less";
</style>